import type { ReactNode } from "react";

export type BannerVariant = "danger" | "info" | "success" | "warning";

type BannerProps = {
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
  id?: string;
  role?: "alert" | "status";
  variant?: BannerVariant;
};

const Banner = ({
  children,
  className = "",
  icon,
  id,
  role = "status",
  variant = "info",
}: BannerProps) => (
  <div
    id={id}
    className={`cle-banner cle-banner--${variant} ${className}`.trim()}
    role={role}
  >
    {icon ? (
      <span className="d-inline-flex flex-shrink-0 " aria-hidden="true">
        {icon}
      </span>
    ) : null}
    <div className="small mb-0 flex-grow-1 min-w-0">{children}</div>
  </div>
);

export default Banner;
